"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const formik_1 = require("formik");
const react_1 = __importDefault(require("react"));
const buttons_1 = require("@/components/base-form/buttons");
const fields_1 = require("@/components/base-form/fields");
const constants_1 = __importDefault(require("@/constants"));
const field_names_1 = require("../field-names");
const schemas_1 = require("../schemas");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const initialValues = {
    [field_names_1.ResetPasswordChangeFieldNames.password]: '',
    [field_names_1.ResetPasswordChangeFieldNames.confirmPassword]: '',
    token: ''
};
const ResetPasswordChangeForm = (formProps) => {
    const { onSubmit, pending } = formProps;
    const onSubmitForm = (values) => {
        onSubmit(values);
    };
    return (react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, onSubmit: onSubmitForm, validationSchema: schemas_1.ResetPasswordChangeSchema }, (props) => {
        const { values, errors, handleChange, handleBlur, handleSubmit } = props;
        const disableSubmitButton = !values[field_names_1.ResetPasswordChangeFieldNames.password] || !values[field_names_1.ResetPasswordChangeFieldNames.confirmPassword] || pending;
        return (react_1.default.createElement("form", { onSubmit: handleSubmit },
            react_1.default.createElement("div", { className: styles_scss_1.default.resetPasswordInputs },
                react_1.default.createElement("div", { className: styles_scss_1.default.resetPasswordInputRow },
                    react_1.default.createElement(fields_1.PasswordField, { name: field_names_1.ResetPasswordChangeFieldNames.password, label: constants_1.default.resetPassword.enterNewPassword, placeholder: constants_1.default.general.enterHere, error: errors[field_names_1.ResetPasswordChangeFieldNames.password], onChange: handleChange, onBlur: handleBlur })),
                react_1.default.createElement("div", { className: styles_scss_1.default.resetPasswordInputRow },
                    react_1.default.createElement(fields_1.PasswordField, { name: field_names_1.ResetPasswordChangeFieldNames.confirmPassword, label: constants_1.default.resetPassword.confirmNewPassword, placeholder: constants_1.default.general.enterHere, error: errors[field_names_1.ResetPasswordChangeFieldNames.confirmPassword], onChange: handleChange, onBlur: handleBlur }))),
            react_1.default.createElement("div", { className: styles_scss_1.default.buttons },
                react_1.default.createElement(buttons_1.SubmitButton, { disableOnErrors: true, ariaLabel: constants_1.default.general.next, title: pending ? constants_1.default.general.loading : constants_1.default.resetPassword.saveNewPassword, className: styles_scss_1.default.submitButton, disabled: disableSubmitButton }))));
    }));
};
exports.default = ResetPasswordChangeForm;
